import PayrollReport from './PayrollReport';

export default PayrollReport;
